// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"d8e67459","151":"b29097e1","453":"3e2d3ee1","745":"1b02b6f4"}[chunkId] + ".chunk.js";
};